import request from '@/utils/request';

export default {
    getReasons: async ({ commit, dispatch }) => {
        await request({ url: '/support/technical/reasons', method: 'get' })
            .then(res => {
                if (res.data) {
                    commit('SET_REASONS', res.data);
                }
            }).catch(err => {
                if (err.response && err.response.data && err.response.data.message) {
                    dispatch('alert/addMessage', {
                        type: 'error',
                    }, { root: true });
                }
            });
    },

    getCards: async({ commit, dispatch }, params) => {
        await request({ url: '/support/technical', method: 'get', params })
            .then(res => {
                if (res.data && res.data.items) {
                    const {totalPages, page, items} = res.data;

                    commit('SET_CARDS', items);
                    commit('SET_PAGINATION', {
                        totalPages,
                        page
                    });
                }
            }).catch(err => {
                if (err.response && err.response.data && err.response.data.message) {
                    dispatch('alert/addMessage', {
                        type: 'error',
                    }, {root: true});
                }
            });
    },

    saveCard: async({ dispatch }, payload) => {
        const { url, method } = payload;

        return request({
            url, method,
            data: {
                ...Object.reject(payload, ['url', 'method'])
            }
        }).then(res => {
            if (res.data) {
                dispatch('alert/addMessage', {
                    type: 'success',
                    message: 'success'
                }, { root: true });

                dispatch('getCards');
            }

            return res.status;
        }).catch(err => {
            if (err.response && err.response.data && err.response.data.error) {
                const message = err.response.status === 404 ? 'support.orderNotFound' : err.response.data.error;

                dispatch('alert/addMessage', {
                    message,
                }, { root: true });
            }
        });
    },

    getPayments: async({ commit, dispatch }, { orderId, fromFp = false }) => {
        const params = {
            url: `/support/payments/${orderId}`,
            mutation: 'SET_PAYMENTS'
        };

        if (fromFp) {
            Object.assign(params, {
                url: `/support/payments/fp/${orderId}`,
                mutation: 'SET_FP_PAYMENTS'
            });
        }

        await request({ url: params.url, method: 'get' })
            .then(res => {
                if (res.data) {
                    commit(params.mutation, res.data);
                }
            }).catch(err => {
                if (err.response && err.response.data && err.response.data.message) {
                    dispatch('alert/addMessage', {
                        type: 'error',
                    }, { root: true });
                }
            });
    },

    getClientInfo: async({ commit, dispatch }, phoneNumber) => {
        await request({
            url: `/support/client/${phoneNumber}`
        }).then(res => {
            if (res.data) {
                commit('SET_CLIENT_INFO', res.data);
            }
        }).catch(err => {
            if (err.response && err.response.data && err.response.data.error) {
                dispatch('alert/addMessage', {
                    type: 'error',
                    message: `support.${err.response.data.error}`
                }, { root: true });
            }
        });
    },

    getFpClientInfo: async({ commit, dispatch }, params) => {
        return request({
            url: `/support/client/fp`,
            params
        }).then(res => {
            if (res.data) {
                commit('SET_CLIENT_INFO', {
                    fromFp: true,
                    ...res.data
                });
            }

            return res;
        }).catch(err => {
            if (err.response && err.response.data && err.response.data.error) {
                dispatch('alert/addMessage', {
                    type: 'error',
                    message: `support.${err.response.data.error}`
                }, { root: true });
            }

            return err.response;
        });
    }
};
